import { lazy, Suspense } from 'react';
import { FullScreenLoadingSpinner } from '@/components/full-screen-loading-spinner';
import { Separator } from '@/components/ui/separator';
const SpeedTest = lazy(() => import('./speed-test'));

const SpeedTestWrapper = () => {
  return (
    <div className="bg-black px-0.5">
      <div className="container flex flex-col items-center pt-10 md:pt-12 lg:pt-20">
        <h1 className="text-white text-3xl md:text-4xl lg:text-5xl font-lateral1000">
          EXETEL SPEED TEST
        </h1>
        <p className="text-white font-nunito300 text-sm md:text-base lg:text-lg text-center mt-4">
          Wondering if you're getting the speeds you were promised? Simple -
          just
          <br className="hidden md:block" /> run an Exetel speed test and find
          out in seconds!
        </p>
        <Suspense
          fallback={<FullScreenLoadingSpinner className="text-white mt-4" />}
        >
          <SpeedTest />
        </Suspense>
        <Separator className="bg-dark-grey-500 mt-4 md:mt-12" />
      </div>
    </div>
  );
};

export default SpeedTestWrapper;
